import NewsFeedInner from '@/components/NewsFeedInner'
import type { ComponentProps } from 'react'

type NewsFeedProps = ComponentProps<typeof NewsFeedInner>

function NewsFeed(props: NewsFeedProps) {
  if (!props.projectKey?.trim())
    return null

  return <NewsFeedInner {...props} />
}

export default NewsFeed
